<template>
  <picture>
    <source :srcset="webp" :sizes="sizes" type="image/webp" />
    <source :srcset="jpeg" :sizes="sizes" type="image/jpeg" />
    <img
      :srcset="this.image.fields.file.url"
      :alt="image.fields.title"
      :class="imgClass"
    />
  </picture>
</template>

<script>
const transformSizes = [2560, 1920, 1600, 1366, 1024, 768, 640];

export default {
  name: "CoreImage",

  props: {
    optimiseImages: {
      type: Boolean,
      default: true
    },
    image: {
      type: Object,
      default: () => ({})
    },
    imgClass: {
      type: String,
      default: ""
    }
  },

  computed: {
    webp() {
      const q = 100;
      if (this.optimiseImages) {
        return transformSizes.map(
          w => `${this.image.fields.file.url}?w=${w}&fm=webp&q=${q} ${w}w`
        );
      }

      return `${this.image.fields.file.url}?fm=webp&q=${q}`;
    },
    jpeg() {
      const q = 80;

      if (this.optimiseImages) {
        return transformSizes.map(
          w => `${this.image.fields.file.url}?w=${w}&fm=jpg&q=${q} ${w}w`
        );
      }

      return `${this.image.fields.file.url}?fm=jpg&q=${q}`;
    },
    sizes() {
      const orderedSizes = [...transformSizes].reverse();
      if (this.optimiseImages) {
        return [
          ...orderedSizes.map(w => `(max-width: ${w}px) ${w}px`),
          `${transformSizes[0]}px`
        ];
      }

      return false;
    },
    fallback() {
      return this.image.fields.file.url;
    }
  }
};
</script>
